import { Component } from 'react';
import React from 'react';
import NativeSelect from '@material-ui/core/NativeSelect';
import { withStyles } from '@material-ui/core/styles';


const StyledNativeSelect = withStyles({
  select: {
    width: '101px'
  }
})(NativeSelect);

class SelectReduxForm extends Component {
  render() {
    const { input: { value, onChange } } = this.props;
    return (
      <StyledNativeSelect
        value={value}
        onChange={(evt) => onChange(evt.target.value)}
      >
        {this.props.options.map(({ id, name }) => <option key={id} value={id}>{name}</option>)}
      </StyledNativeSelect>
    );
  }
}

export default SelectReduxForm;



// WEBPACK FOOTER //
// ./src/components/SelectReduxForm.js